import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"
import { Modal } from "../utils/modal"

export default class WhatsAppQRController extends Controller {
  static values = {
    phoneNumber: String,
    accessCode: String
  }

  static targets = ["image", "message", "link", "container"]

  static WHATSAPP_BASE_URL = "https://wa.me"
  static WHATSAPP_URL_LIMIT = 4096
  static QR_FILE_NAME = "qrcode.png"
  static QR_IMAGE_TYPE = "image/svg+xml"
  static CODE_PLACEHOLDER = "{code}"

  #qrCodeUri = null

  connect() {
    this.ERROR_MESSAGE_CODE = window.I18n.notifications.qr_code_validation_error;
    this.ERROR_MESSAGE_LENGTH = window.I18n.notifications.qr_code_length_error;
  }

  generate() {
    if (!this.#validateMessage()) {
      Modal.danger({
        title: window.I18n.modal.danger.title,
        message: window.I18n.notifications.qr_code_validation_error,
        confirmText: window.I18n.general.okay
      });
      return
    }

    const url = this.#generateWhatsAppUrl()

    if (url.length > WhatsAppQRController.WHATSAPP_URL_LIMIT) {
      Modal.danger({
        title: window.I18n.modal.danger.title,
        message: window.I18n.notifications.qr_code_length_error,
        confirmText: window.I18n.general.okay
      });
      return
    }

    this.linkTarget.textContent = url
    this.containerTarget.classList.remove("d-none")

    QRCode.toDataURL(url, { type: WhatsAppQRController.QR_IMAGE_TYPE })
      .then(uri => {
        this.#qrCodeUri = uri
        this.imageTarget.src = uri
      })
      .catch(error => {
        console.error("QR code generation error:", error)
      })
  }

  download() {
    if (!this.#qrCodeUri) return

    const downloadLink = document.createElement("a")
    downloadLink.href = this.#qrCodeUri
    downloadLink.download = WhatsAppQRController.QR_FILE_NAME
    downloadLink.click()
  }

  remove() {
    this.containerTarget.classList.add("d-none")
    this.linkTarget.textContent = ""
    this.imageTarget.src = ""
  }

  #validateMessage() {
    if (this.accessCodeValue) return this.messageTarget.value.includes(WhatsAppQRController.CODE_PLACEHOLDER)
    return true
  }

  #generateWhatsAppUrl() {
    const formattedPhoneNumber = this.phoneNumberValue.replaceAll(' ', '')
    const message = encodeURIComponent(
      this.messageTarget.value.replace(WhatsAppQRController.CODE_PLACEHOLDER, `${this.accessCodeValue}`)
    )

    return `${WhatsAppQRController.WHATSAPP_BASE_URL}/${formattedPhoneNumber}${message ? `?text=${message}` : ''}`

  }
}
